import styled from 'styled-components';
import { Button } from '../input/Button';

export const ActionButton = styled(Button)
    .withConfig({ displayName: 'ActionButton' })
    .attrs((props) => ({
        width: '100%',
        height: '46px',
        size: 'm',
        p: 2,
        ...props,
    }))``;
